enum TypeReport {
	BUDGET_PRIMITIF = 1,
	BUDGET_SUPPLEMENTAIRE = 2,
	DECISION_MODIFICATIVE = 3,
}

export default TypeReport;
